<template>
    <ui-intersection-observer @intersect-enter="onEnter">
        <slot v-if="isVisible"/>
    </ui-intersection-observer>
</template>

<script>
    import UiIntersectionObserver from '@dreipol/vue-ui/src/components/intersection-observer/intersection-observer';

    export default {
        components: { UiIntersectionObserver },

        data() {
            return {
                isVisible: true,
            };
        },

        methods: {
            onEnter() {
                this.isVisible = true;
            },
        },
    };
</script>
